import { LoaderFunction, useLoaderData } from "react-router-dom";
import { getAsset } from "../../../common/api/bridge/methods.ts";

export const activateLoader: LoaderFunction = ({ params }) => {
  return getAsset(params.vbid!);
};

export function useActivateLoaderData() {
  return useLoaderData<VST.Bridge.Asset>();
}
